module.exports = __webpack_public_path__ + "static/media/bitmap@1x.faee071e.jpg";